(function () {
  window.TakeDriveMainResultsFactory = function (scope) {
    scope = scope || {};
    if (!scope.takeDriveResultsAssetUrls) {
      scope.takeDriveResultsAssetUrls = {};
    }

    with (scope) {
      var onDetailsSelectionStateChange = typeof scope.onDetailsSelectionStateChange === 'function'
        ? scope.onDetailsSelectionStateChange
        : function () {};
      function getDisplayAmbassadorItems(items) {
        return (Array.isArray(items) ? items : []).filter(function (item) {
          return !!(item && item.resultKind === 'ambassador');
        });
      }

      function getMapAmbassadorItems(items) {
        return getDisplayAmbassadorItems(items)
          .slice()
          .sort(function (a, b) {
            var left = Number(a && a.distanceKm);
            var right = Number(b && b.distanceKm);
            var normalizedLeft = Number.isFinite(left) ? left : Number.POSITIVE_INFINITY;
            var normalizedRight = Number.isFinite(right) ? right : Number.POSITIVE_INFINITY;
            return normalizedLeft - normalizedRight;
          })
          .slice(0, 1);
      }

      function buildChoiceAvatarStackMarkup(items) {
        var entries = getDisplayAmbassadorItems(items).slice(0, 8).map(function (item) {
          var avatarUrls = getAmbassadorAvatarUrls(item);
          if (avatarUrls.length) {
            return '<span class="take-drive-page__choice-avatar-stack-item"><img src="' + escapeHtml(avatarUrls[0]) + '" alt="" loading="lazy" decoding="async"></span>';
          }
          var initials = String(item && item.name || 'A').trim().split(/\s+/).map(function (part) {
            return String(part || '').charAt(0).toUpperCase();
          }).join('').slice(0, 2) || 'A';
          return '<span class="take-drive-page__choice-avatar-stack-item"><span class="take-drive-page__choice-avatar-stack-fallback">' + escapeHtml(initials) + '</span></span>';
        }).join('');
        return entries ? '<div class="take-drive-page__choice-avatar-stack">' + entries + '</div>' : '';
      }

      function getNearestAmbassadorDistanceKm(items) {
        var nearestDistance = Number.POSITIVE_INFINITY;
        getDisplayAmbassadorItems(items).forEach(function (item) {
          var distanceKm = Number(item && item.distanceKm);
          if (Number.isFinite(distanceKm) && distanceKm >= 0 && distanceKm < nearestDistance) {
            nearestDistance = distanceKm;
          }
        });
        return Number.isFinite(nearestDistance) ? nearestDistance : null;
      }

      function buildAmbassadorGroupDistanceLabel(items) {
        var nearestDistanceKm = getNearestAmbassadorDistanceKm(items);
        if (nearestDistanceKm === null) return '';
        return formatDistanceAwayDisplay(formatDistanceDisplayFromKm(nearestDistanceKm));
      }

      function getChoiceLocationLabel(item) {
        var subtitle = String(item && item.subtitle || '').trim();
        if (subtitle && item && item.resultKind !== 'dealer_workshop') return subtitle;
        var addressParts = String(item && item.address || '')
          .split(',')
          .map(function (part) { return String(part || '').trim(); })
          .filter(Boolean);
        if (addressParts.length >= 2) return addressParts[Math.max(0, addressParts.length - 2)];
        if (addressParts.length) return addressParts[0];
        return '';
      }

      function buildResultDisplayNameMarkup(item) {
        var name = String(item && item.name || '').trim();
        var subtitle = String(item && item.subtitle || '').trim();
        if (!subtitle || subtitle === name) return escapeHtml(name);
        return escapeHtml(name) + ' <span class="take-drive-google-map__result-name-extra">(' + escapeHtml(subtitle) + ')</span>';
      }

      function formatChoiceSessionDate(group) {
        if (group && group.dateObj instanceof Date && !Number.isNaN(group.dateObj.getTime())) {
          return formatWorkshopMonthLong(group.dateObj) + ' ' + String(group.dateObj.getDate()) + ', ' + String(group.dateObj.getFullYear());
        }
        return String(group && group.rawDateLabel || '').trim();
      }

      function buildChoiceWorkshopSessionsMarkup(item) {
        if (!item || (item.resultKind !== 'workshop' && item.resultKind !== 'dealer_workshop')) return '';

        var selectedIds = {};
        getSelectedWorkshopSessionIdsForResult(item).forEach(function (id) {
          selectedIds[String(id)] = true;
        });
        if (!Object.keys(selectedIds).length) return '';

        var locationLabel = getChoiceLocationLabel(item) || 'Session';
        var sessionCards = (Array.isArray(item.workshopScheduleGroups) ? item.workshopScheduleGroups : []).map(function (group) {
          var selectedSlots = (Array.isArray(group && group.slots) ? group.slots : []).filter(function (slot) {
            return !!selectedIds[String(slot && slot.id || '')];
          });
          if (!selectedSlots.length) return '';

          var dateLabel = formatChoiceSessionDate(group);
          var title = [locationLabel, dateLabel].filter(Boolean).join(' - ');
          var slotsHtml = selectedSlots.map(function (slot) {
            return '<span class="take-drive-page__choice-session-pill">' + escapeHtml(String(slot && slot.label || '').trim()) + '</span>';
          }).join('');

          return ''
            + '<div class="take-drive-page__choice-session-card">'
            + '  <div class="take-drive-page__choice-session-date">' + escapeHtml(title) + '</div>'
            + '  <div class="take-drive-page__choice-session-pills">' + slotsHtml + '</div>'
            + '</div>';
        }).filter(Boolean).join('');

        if (!sessionCards) return '';

        return ''
          + '<div class="take-drive-page__choice-session-section">'
          + '  <div class="take-drive-page__choice-session-heading">' + escapeHtml(takeDriveUiCopy.selectedSessionsHeading) + '</div>'
          + '  <div class="take-drive-page__choice-session-list">' + sessionCards + '</div>'
          + '</div>';
      }

      function buildAmbassadorChoiceSummaryMarkup(items) {
        var ambassadors = getDisplayAmbassadorItems(items);
        if (!ambassadors.length) return '';
        var distanceLabel = buildAmbassadorGroupDistanceLabel(ambassadors);
        var countLabel = String(ambassadors.length) + ' ' + takeDriveUiCopy.ambassadorGroupCountSuffix;
        return ''
          + '<div class="take-drive-page__choice-stack">'
          + '  <div class="take-drive-page__choice-card take-drive-page__choice-card--selected take-drive-page__choice-card--ambassador">'
          + '    <div class="take-drive-page__choice-card-inner">'
          +          buildChoiceAvatarStackMarkup(ambassadors)
          + '      <div class="take-drive-page__choice-main">'
          + '        <div class="take-drive-page__choice-name">' + escapeHtml(takeDriveUiCopy.ambassadorGroupTitle) + '</div>'
          + (distanceLabel ? '        <div class="take-drive-page__choice-distance">' + escapeHtml(distanceLabel) + '</div>' : '')
          + '        <div class="take-drive-page__choice-ambassador-count">' + escapeHtml(countLabel) + '</div>'
          + '      </div>'
          + '    </div>'
          + '  </div>'
          + '</div>';
      }

      function buildResultChoiceSummaryMarkup(item) {
        if (!item) return '';

        var infoLines = [];
        var badges = Array.isArray(item.badges) ? item.badges : [];
        if (item.resultKind === 'dealer') {
          if (item.address) infoLines.push(item.address);
          if (item.website) infoLines.push(buildChoiceWebsiteLine(item.website));
          if (item.distanceKm !== null && item.distanceKm !== undefined && Number.isFinite(Number(item.distanceKm))) {
            infoLines.push(formatDistanceAwayDisplay(formatDistanceDisplayFromKm(item.distanceKm)));
          }
          return buildStandardChoiceSummaryMarkup(item, infoLines, badges, '');
        } else if (item.resultKind === 'dealer_workshop') {
          if (item.address) infoLines.push(item.address);
          if (item.website) infoLines.push(buildChoiceWebsiteLine(item.website));
          if (item.distanceKm !== null && item.distanceKm !== undefined && Number.isFinite(Number(item.distanceKm))) {
            infoLines.push(formatDistanceAwayDisplay(formatDistanceDisplayFromKm(item.distanceKm)));
          }
          return buildStandardChoiceSummaryMarkup(item, infoLines, badges, buildChoiceWorkshopSessionsMarkup(item));
        } else if (item.resultKind === 'workshop') {
          if (item.address) infoLines.push(item.address);
          if (item.website) infoLines.push(buildChoiceWebsiteLine(item.website));
          if (item.distanceKm !== null && item.distanceKm !== undefined && Number.isFinite(Number(item.distanceKm))) {
            infoLines.push(formatDistanceAwayDisplay(formatDistanceDisplayFromKm(item.distanceKm)));
          }
          if (!badges.length && takeDriveUiCopy.workshopBadge) {
            badges = [takeDriveUiCopy.workshopBadge];
          }
          return buildStandardChoiceSummaryMarkup(item, infoLines, badges, buildChoiceWorkshopSessionsMarkup(item));
        } else {
          if (item.address) infoLines.push(item.address);
          if (item.website) infoLines.push(buildChoiceWebsiteLine(item.website));
          var ambassadorEv1StartText = formatAmbassadorEv1StartText(item.ambassadorEv1StartAt);
          if (ambassadorEv1StartText) infoLines.push(ambassadorEv1StartText);
          if (item.businessHours) infoLines.push(item.businessHours);
          if (item.phone) infoLines.push(item.phone);
        }
        var sessionMarkup = buildChoiceWorkshopSessionsMarkup(item);
        return buildStandardChoiceSummaryMarkup(item, infoLines, badges, sessionMarkup);
      }

      function syncMarkerStates() {
        var selectedAmbassadorCodes = {};
        getSelectedAmbassadorResults().forEach(function (item) {
          var code = String(item && item.code || '').trim();
          if (code) selectedAmbassadorCodes[code] = true;
        });
        var hasActiveAmbassadorSelection = Object.keys(selectedAmbassadorCodes).length > 0;
        storeMarkers.forEach(function (marker) {
          var item = marker.__item;
          var isActive = false;
          if (item && item.resultKind === 'ambassador') {
            var ambassadorCode = String(item.code || '').trim();
            isActive = !!selectedAmbassadorCodes[ambassadorCode]
              || isSelectedResultIdentity({ code: ambassadorCode, resultKind: 'ambassador' });
          } else if (isAmbassadorGroupMarkerItem(item)) {
            isActive = hasActiveAmbassadorSelection;
          } else {
            isActive = isSelectedResultIdentity(item);
          }
          updateStoreMarkerAppearance(marker, item, isActive);
        });
      }

      function getSelectedResultCard() {
        return document.querySelector('#take-drive-map-results .take-drive-google-map__result-card.is-active, #take-drive-map-results .take-drive-google-map__ambassador-card.is-active');
      }

      function isExpanded(code) {
        return expandedStoreCodes.indexOf(String(code || '')) > -1;
      }

      function ensureExpanded(code) {
        var normalized = String(code || '').trim();
        if (!normalized) return;
        if (expandedStoreCodes.indexOf(normalized) === -1) {
          expandedStoreCodes.push(normalized);
        }
      }

      function buildResultBadgesHtml(item) {
        var badges = Array.isArray(item) ? item.filter(Boolean) : (Array.isArray(item && item.badges) ? item.badges.filter(Boolean) : []);
        if (!badges.length) return '';
        return badges.map(function (badgeText) {
          var className = 'take-drive-google-map__result-badge';
          var normalizedBadgeText = String(badgeText || '').trim();
          var upperText = normalizedBadgeText.toUpperCase();
          var ambassadorCountSuffix = String(takeDriveUiCopy.ambassadorGroupCountSuffix || '').trim().toUpperCase();

          if (upperText === 'COMING SOON') {
            className += ' take-drive-google-map__result-badge--coming-soon';
          } else if (ambassadorCountSuffix && upperText.indexOf(ambassadorCountSuffix) > -1) {
            className += ' take-drive-google-map__result-badge--ambassador';
          } else if (
            isSessionAvailabilityBadgeLabel(normalizedBadgeText) ||
            normalizedBadgeText === String(takeDriveUiCopy.workshopBadge || '').trim()
          ) {
            className += ' take-drive-google-map__result-badge--accent';
          } else {
            className += ' take-drive-google-map__result-badge--neutral';
          }

          return '<div class="' + className + '">' + escapeHtml(normalizedBadgeText) + '</div>';
        }).join('');
      }

      function buildWorkshopAppliedHtml(item) {
        if (!item || (item.resultKind !== 'workshop' && item.resultKind !== 'dealer_workshop')) return '';
        var appliedCount = parseNumber(item.workshopAppliedCount);
        if (!Number.isFinite(appliedCount)) return '';
        if (appliedCount <= 0) return '';
        var appliedSuffix = appliedCount === 1
          ? takeDriveUiCopy.workshopAppliedSuffixOne
          : takeDriveUiCopy.workshopAppliedSuffix;
        return ''
          + '<div class="take-drive-google-map__workshop-applied">'
          + '  <img class="take-drive-google-map__workshop-applied-icon" src="' + escapeHtml(takeDriveResultsAssetUrls.peopleApplied || '') + '" alt="" width="18" height="18" loading="lazy" decoding="async">'
          + '  <span class="take-drive-google-map__workshop-applied-text">' + escapeHtml(String(appliedCount)) + ' ' + escapeHtml(appliedSuffix) + '</span>'
          + '</div>';
      }

      function buildWorkshopNoticeHtml(text) {
        var content = decodeHtmlEntities(String(text || '').trim());
        if (!content) return '';
        return ''
          + '<div class="take-drive-google-map__workshop-note">'
          + '  <img class="take-drive-google-map__workshop-note-icon" src="' + escapeHtml(takeDriveResultsAssetUrls.know || '') + '" alt="" width="18" height="18" loading="lazy" decoding="async">'
          + '  <div class="take-drive-google-map__workshop-note-text">' + escapeHtmlWithBreaks(content) + '</div>'
          + '</div>';
      }

      function buildWorkshopScheduleHtml(item) {
        if (isType5Workshop(item)) return '';
        var scheduleGroups = Array.isArray(item && item.workshopScheduleGroups) ? item.workshopScheduleGroups : [];
        if (!scheduleGroups.length) return '';
        var selectedIds = {};
        getSelectedWorkshopSessionIdsForResult(item).forEach(function (id) {
          selectedIds[String(id)] = true;
        });
        var isSelectableWorkshop = item && (item.resultKind === 'workshop' || item.resultKind === 'dealer_workshop');
        var rows = scheduleGroups.map(function (group) {
          var slotCount = Array.isArray(group && group.slots) ? group.slots.length : 0;
          var chips = (Array.isArray(group.slots) ? group.slots : []).map(function (slotText) {
            var slotId = String(slotText && slotText.id || '').trim();
            var slotLabel = String(slotText && slotText.label || '').trim();
            if (!slotLabel) return '';
            if (!isSelectableWorkshop) {
              return '<div class="take-drive-google-map__workshop-slot">' + escapeHtml(slotLabel) + '</div>';
            }
            var isSelected = !!selectedIds[slotId];
            return ''
              + '<button class="take-drive-google-map__workshop-slot take-drive-google-map__workshop-slot-button' + (isSelected ? ' is-selected' : '') + '"'
              + ' type="button"'
              + ' data-store-code="' + escapeHtml(item.code) + '"'
              + ' data-session-id="' + escapeHtml(slotId) + '"'
              + ' aria-pressed="' + (isSelected ? 'true' : 'false') + '">'
              +   escapeHtml(slotLabel)
              + '</button>';
          }).join('');
          return ''
            + '<div class="take-drive-google-map__workshop-schedule-row' + (slotCount === 1 ? ' take-drive-google-map__workshop-schedule-row--single' : '') + '">'
            + '  <div class="take-drive-google-map__workshop-date">'
            + '    <div class="take-drive-google-map__workshop-date-month">' + escapeHtml(group.monthLabel || '') + '</div>'
            + '    <div class="take-drive-google-map__workshop-date-day">' + escapeHtml(group.dayLabel || '') + '</div>'
            + '  </div>'
            + '  <div class="take-drive-google-map__workshop-slots">' + chips + '</div>'
            + '</div>';
        }).join('');
        return ''
          + '<div class="take-drive-google-map__workshop-schedule">'
          + rows
          + '</div>';
      }

      function canContinueWithSelectedResult() {
        if (!selectedResult) return false;
        var reservationType = getReservationType(selectedResult);
        if ([2, 3].indexOf(Number(reservationType)) !== -1
          && (selectedResult.resultKind === 'workshop' || selectedResult.resultKind === 'dealer_workshop')) {
          return getSelectedWorkshopSessionIdsForResult(selectedResult).length > 0;
        }
        return true;
      }

      function buildResultCardHtml(item) {
        var reservationType = getReservationType(item);
        var isType5Waitlist = isType5Workshop(item);
        var useToggleHotspot = item.resultKind === 'dealer'
          || item.resultKind === 'workshop'
          || item.resultKind === 'dealer_workshop';
        var cardClassName = item && item.resultKind === 'ambassador'
          ? 'take-drive-google-map__ambassador-card'
          : 'take-drive-google-map__result-card';
        var badges = Array.isArray(item && item.badges) ? item.badges.filter(Boolean) : [];
        var summaryDetails = [];
        var expandedDetails = [];
        var ambassadorDetails = [];
        var usesStackedSummaryLayout = item.resultKind === 'workshop'
          || item.resultKind === 'dealer_workshop'
          || item.resultKind === 'dealer'
          || item.resultKind === 'ambassador';
        var distanceDisplay = formatDistanceDisplayFromKm(item.distanceKm);
        var stackedDistanceHtml = '';
        var stackedMetaHtml = '';
        if (item.resultKind === 'ambassador') {
          var ambassadorEv1StartText = formatAmbassadorEv1StartText(item.ambassadorEv1StartAt);
          if (ambassadorEv1StartText) {
            stackedMetaHtml += '<div class="take-drive-google-map__result-distance take-drive-google-map__result-distance--muted">' + escapeHtml(ambassadorEv1StartText) + '</div>';
          }
        }
        if (item.resultKind !== 'ambassador' && item.address) {
          summaryDetails.push('<div class="take-drive-google-map__result-line take-drive-google-map__result-line--address">' + escapeHtmlWithBreaks(item.address) + '</div>');
        }
        if (item.resultKind !== 'ambassador' && item.website && item.resultKind !== 'workshop') {
          var href = item.website.indexOf('http') === 0 ? item.website : 'https://' + item.website;
          summaryDetails.push('<div class="take-drive-google-map__result-line take-drive-google-map__result-line--website"><a href="' + escapeHtml(href) + '" target="_blank" rel="noopener noreferrer" style="color: inherit; text-decoration: underline;">' + escapeHtml(item.website) + '</a></div>');
        }
        if (item.resultKind !== 'ambassador' && item.businessHours) {
          expandedDetails.push('<div class="take-drive-google-map__result-line take-drive-google-map__result-line--hours">' + escapeHtmlWithBreaks(item.businessHours) + '</div>');
        }
        if (item.resultKind !== 'ambassador' && item.phone) {
          expandedDetails.push('<div class="take-drive-google-map__result-line take-drive-google-map__result-line--phone">' + escapeHtml(item.phone) + '</div>');
        }
        if (usesStackedSummaryLayout && distanceDisplay) {
          if (item.resultKind === 'ambassador') {
            stackedDistanceHtml = '<div class="take-drive-google-map__result-distance take-drive-google-map__result-distance--muted">' + escapeHtml(formatMutedDistanceDisplay(distanceDisplay)) + '</div>';
          } else {
            stackedDistanceHtml = '<span class="take-drive-google-map__result-distance take-drive-google-map__result-distance--inline"> (' + escapeHtml(formatDistanceAwayDisplay(distanceDisplay)) + ')</span>';
          }
        }
        var isActive = item.resultKind === 'ambassador'
          ? false
          : isSelectedResultIdentity(item);
        var isExpandedState = item.resultKind === 'ambassador' ? true : isExpanded(item.code);
        var avatarMarkup = '';
        if (item.avatarUrl) {
          avatarMarkup = '<img src="' + escapeHtml(item.avatarUrl) + '" alt="" loading="lazy" decoding="async">';
        } else if (item.resultKind === 'ambassador') {
          var initials = String(item.name || 'A').trim().split(/\s+/).map(function (part) {
            return String(part || '').charAt(0).toUpperCase();
          }).join('').slice(0, 2) || 'A';
          avatarMarkup = '<span class="take-drive-google-map__result-avatar-fallback">' + escapeHtml(initials) + '</span>';
        } else {
          var avatarUrl = getResultCardIcon(item);
          if (avatarUrl) {
            avatarMarkup = '<img src="' + escapeHtml(avatarUrl) + '" alt="" loading="lazy" decoding="async">';
          }
        }
        var workshopNotice = '';
        if (item.resultKind === 'workshop') {
          if (isType5Waitlist) {
            workshopNotice += buildWorkshopNoticeHtml(takeDriveUiCopy.workshopWaitlistDepositNotice);
            workshopNotice += buildWorkshopNoticeHtml(takeDriveUiCopy.workshopWaitlistPendingNotice);
          } else {
            workshopNotice += buildWorkshopNoticeHtml(takeDriveUiCopy.workshopNoticeDeposit);
            workshopNotice += buildWorkshopNoticeHtml(takeDriveUiCopy.workshopNoticeMinimum);
          }
        }
        var defaultBadgesHtml = '';
        var summaryBadgesHtml = '';
        if (badges.length && item.resultKind !== 'ambassador') {
          summaryBadgesHtml = '<div class="take-drive-google-map__result-badges">' + buildResultBadgesHtml(badges) + '</div>';
        }
        if (!usesStackedSummaryLayout && badges.length && item.resultKind !== 'ambassador') {
          defaultBadgesHtml = '<div class="take-drive-google-map__result-badges">' + buildResultBadgesHtml(badges) + '</div>';
        }
        var workshopNoticeDividerHtml = Number(reservationType) === 3 && workshopNotice
          ? '<div class="take-drive-google-map__result-divider take-drive-google-map__result-divider--workshop" aria-hidden="true"></div>'
          : '';
        var workshopAppliedHtml = buildWorkshopAppliedHtml(item);
        var workshopScheduleHtml = buildWorkshopScheduleHtml(item);
        var workshopScheduleDividerHtml = workshopScheduleHtml
          ? '<div class="take-drive-google-map__result-divider take-drive-google-map__result-divider--workshop" aria-hidden="true"></div>'
          : '';
        var resultPrimaryBodyHtml = '';
        var resultSecondaryBodyHtml = '';
        var resultTertiaryBodyHtml = '';
        var resultStandaloneDividerHtml = '';
        var resultSummaryHtml = '';
        var expandedDetailsHtml = expandedDetails.length
          ? ('  <div class="take-drive-google-map__result-details">' + expandedDetails.join('') + '</div>')
          : '';
        var expandedSummaryDetailsHtml = (Number(reservationType) === 1 || Number(reservationType) === 2) && expandedDetails.length
          ? ('  <div class="take-drive-google-map__result-details take-drive-google-map__result-details--summary take-drive-google-map__result-details--expand-only">' + expandedDetails.join('') + '</div>')
          : '';
        var expandedHeaderDetailsHtml = Number(reservationType) === 3 && expandedDetails.length
          ? ('  <div class="take-drive-google-map__result-details take-drive-google-map__result-details--expand-only">' + expandedDetails.join('') + '</div>')
          : '';
        var nonStackedDetails = summaryDetails.concat(expandedDetails);
        var nonStackedDetailsHtml = nonStackedDetails.length
          ? ('  <div class="take-drive-google-map__result-details">' + nonStackedDetails.join('') + '</div>')
          : '';
        if (usesStackedSummaryLayout) {
          if (item.resultKind !== 'ambassador') {
            resultSummaryHtml = ''
              + '<div class="take-drive-google-map__result-summary">'
              + '  <div class="take-drive-google-map__result-name">' + buildResultDisplayNameMarkup(item) + stackedDistanceHtml + '</div>'
              + (summaryDetails.length ? '  <div class="take-drive-google-map__result-details take-drive-google-map__result-details--summary">' + summaryDetails.join('') + '</div>' : '')
              + expandedSummaryDetailsHtml
              + expandedHeaderDetailsHtml
              + summaryBadgesHtml
              + '</div>';
          }
        }
        if (Number(reservationType) === 2) {
          resultPrimaryBodyHtml = ''
            + '<div class="take-drive-google-map__result-body">'
            +    workshopAppliedHtml
            + '</div>';
          resultStandaloneDividerHtml = workshopScheduleDividerHtml;
          resultTertiaryBodyHtml = workshopScheduleHtml
            ? '<div class="take-drive-google-map__result-body">' + workshopScheduleHtml + '</div>'
            : '';
        } else if (Number(reservationType) === 3) {
          resultPrimaryBodyHtml = ''
            + '<div class="take-drive-google-map__result-body">'
            +    workshopAppliedHtml
            +    workshopNotice
            + '</div>';
          resultStandaloneDividerHtml = workshopScheduleHtml ? workshopScheduleDividerHtml : workshopNoticeDividerHtml;
          resultSecondaryBodyHtml = workshopScheduleHtml
            ? ('<div class="take-drive-google-map__result-body">' + workshopScheduleHtml + '</div>')
            : '';
        } else if (Number(reservationType) === 5) {
          resultPrimaryBodyHtml = ''
            + '<div class="take-drive-google-map__result-body take-drive-google-map__result-body--waitlist">'
            +    workshopAppliedHtml
            +    workshopNotice
            + '</div>';
        } else {
          resultPrimaryBodyHtml = ''
            + '<div class="take-drive-google-map__result-body">'
            + (item.resultKind === 'ambassador' && ambassadorDetails.length ? '  <div class="take-drive-google-map__result-details">' + ambassadorDetails.join('') + '</div>' : '')
            + (usesStackedSummaryLayout && (Number(reservationType) === 1 || Number(reservationType) === 2 || Number(reservationType) === 3) ? '' : (usesStackedSummaryLayout ? expandedDetailsHtml : nonStackedDetailsHtml))
            +    defaultBadgesHtml
            +    workshopAppliedHtml
            +    workshopNotice
            +    workshopScheduleHtml
            + '</div>';
        }
        var hotspotBodyHtml = '';
        var headerHtml = '';
        var actionIconsHtml = '';
        if (useToggleHotspot) {
          actionIconsHtml = ''
            + '<span class="take-drive-google-map__result-action-icons" aria-hidden="true">'
            + '  <span class="take-drive-google-map__result-toggle">'
            + '    <img class="take-drive-google-map__result-toggle-icon take-drive-google-map__result-toggle-icon--collapsed" src="' + escapeHtml(takeDriveResultsAssetUrls.rightWhite || '') + '" alt="" width="24" height="24" loading="lazy" decoding="async">'
            + '    <img class="take-drive-google-map__result-toggle-icon take-drive-google-map__result-toggle-icon--expanded" src="' + escapeHtml(takeDriveResultsAssetUrls.down || '') + '" alt="" width="24" height="24" loading="lazy" decoding="async">'
            + '  </span>'
            + '  <span class="take-drive-google-map__result-selected-indicator">'
            + '    <span class="take-drive-google-map__result-selected-indicator-badge">'
            + '      <img src="' + escapeHtml(takeDriveResultsAssetUrls.checkmark || '') + '" alt="" width="16" height="16" loading="lazy" decoding="async">'
            + '    </span>'
            + '  </span>'
            + '</span>';
        }
        if (usesStackedSummaryLayout) {
          if (item.resultKind === 'ambassador') {
            headerHtml = ''
              + '<div class="take-drive-google-map__result-header take-drive-google-map__result-header--stacked">'
              + '  <div class="take-drive-google-map__result-header-top">'
              + (avatarMarkup ? '    <span class="take-drive-google-map__result-avatar">' + avatarMarkup + '</span>' : '')
              + '    <div class="take-drive-google-map__result-summary take-drive-google-map__result-summary--ambassador">'
              + '      <div class="take-drive-google-map__result-name">' + buildResultDisplayNameMarkup(item) + '</div>'
              +        stackedMetaHtml
              +        stackedDistanceHtml
              + '    </div>'
              + '  </div>'
              + '</div>';
          } else {
            headerHtml = ''
              + '<div class="take-drive-google-map__result-header take-drive-google-map__result-header--stacked">'
              + '  <div class="take-drive-google-map__result-header-top">'
              + (avatarMarkup ? '    <span class="take-drive-google-map__result-avatar">' + avatarMarkup + '</span>' : '')
              + '  </div>'
              + resultSummaryHtml
              + '</div>';
          }
        } else {
          headerHtml = ''
            + '<div class="take-drive-google-map__result-header">'
            + (avatarMarkup ? '    <span class="take-drive-google-map__result-avatar">' + avatarMarkup + '</span>' : '')
            + '    <div class="take-drive-google-map__result-name">' + buildResultDisplayNameMarkup(item) + '</div>'
            + '    <div class="take-drive-google-map__result-meta">'
            + '      <div class="take-drive-google-map__result-distance">' + escapeHtml(formatDistanceAwayDisplay(distanceDisplay)) + '</div>'
            + '    </div>'
            + '  </div>';
        }
        var hotspotHtml = '';
        if (useToggleHotspot) {
          hotspotHtml = ''
            + '<div class="take-drive-google-map__result-hotspot"'
            + ' role="button" tabindex="0"'
            + ' data-result-hotspot="true"'
            + ' aria-expanded="' + (isExpandedState ? 'true' : 'false') + '"'
            + ' aria-pressed="' + (isActive ? 'true' : 'false') + '">'
            + '  <div class="take-drive-google-map__result-hotspot-main">'
            +        headerHtml
            +        hotspotBodyHtml
            + '  </div>'
            +      actionIconsHtml
            + '</div>';
        }
        return ''
          + '<article class="' + cardClassName + (isType5Waitlist ? ' take-drive-google-map__result-card--waitlist' : '') + (isActive ? ' is-active' : '') + (isExpandedState ? ' is-expanded' : '') + '"'
          + ' data-store-code="' + escapeHtml(item.code) + '"'
          + ' data-scenario="' + escapeHtml(item.scenario || 'dealer') + '"'
          + ' data-result-kind="' + escapeHtml(item.resultKind || 'dealer') + '"'
          + ' data-session-ids="' + escapeHtml((item.sessionIds || []).join(',')) + '"'
          + ' data-session-summary="' + escapeHtml(item.sessionSummary || '') + '"'
          + (useToggleHotspot ? '' : ' role="button" tabindex="0" aria-expanded="' + (isExpandedState ? 'true' : 'false') + '" aria-pressed="' + (isActive ? 'true' : 'false') + '"')
          + '>'
          +      (useToggleHotspot ? hotspotHtml : headerHtml)
          + '  <div class="take-drive-google-map__result-expanded">'
          +      resultPrimaryBodyHtml
          +      resultStandaloneDividerHtml
          +      resultSecondaryBodyHtml
          +      resultTertiaryBodyHtml
          + '  </div>'
          + '</article>';
      }

      function syncDiscoveryButtonState() {
        if (!supplementalBtn) return;
        var enabled = !!selectedResult || getEffectiveSelectedAmbassadorResults().length > 0;
        if (supplementalBtnWrap) {
          supplementalBtnWrap.style.display = enabled && !isDetailsSectionInView ? '' : 'none';
        }
        setCtaButtonDisabled(supplementalBtn, !enabled, supplementalBtnWrap);
      }


      function syncDetailsSubmitButtonState() {
        onDetailsSelectionStateChange({
          hasSelection: !!selectedResult || getEffectiveSelectedAmbassadorResults().length > 0
        });
      }

      function updateChoiceSummary() {
        if (!choiceSummaryEl) {
          syncDetailsSubmitButtonState();
          return;
        }
        var selectedAmbassadors = getEffectiveSelectedAmbassadorResults();
        if (!selectedResult && !selectedAmbassadors.length) {
          if (choiceSection) {
            choiceSection.style.display = '';
          }
          choiceSummaryEl.innerHTML = '<div class="take-drive-page__choice-empty">' + escapeHtml(takeDriveUiCopy.choiceEmpty) + '</div>';
          syncDetailsSubmitButtonState();
          return;
        }
        if (isFallbackResult(selectedResult)) {
          var fallbackChoiceAvatarMarkup = buildChoiceAvatarMarkupForResult(selectedResult);
          if (choiceSection) {
            choiceSection.style.display = '';
          }
          choiceSummaryEl.innerHTML = ''
            + '<div class="take-drive-page__choice-stack">'
            + '  <div class="take-drive-page__choice-card take-drive-page__choice-card--selected">'
            + '    <div class="take-drive-page__choice-card-inner">'
            + '      <div class="take-drive-page__choice-card-header">'
            +          fallbackChoiceAvatarMarkup
            + '        <div class="take-drive-page__choice-card-content">'
            + '          <div class="take-drive-page__choice-name take-drive-page__choice-name--fallback">' + escapeHtml(selectedResult.name) + '</div>'
            + '        </div>'
            + '      </div>'
            + (selectedResult.address
              ? '      <div class="take-drive-page__choice-copy take-drive-page__choice-copy--fallback">' + escapeHtmlWithBreaks(selectedResult.address || '') + '</div>'
              : '')
            + '    </div>'
            + '  </div>'
            + '</div>';
          syncDetailsSubmitButtonState();
          return;
        }
        if (choiceSection) {
          choiceSection.style.display = '';
        }
        if (selectedAmbassadors.length) {
          choiceSummaryEl.innerHTML = buildAmbassadorChoiceSummaryMarkup(selectedAmbassadors);
          syncDetailsSubmitButtonState();
          return;
        }
        choiceSummaryEl.innerHTML = buildResultChoiceSummaryMarkup(selectedResult);
        syncDetailsSubmitButtonState();
      }

      function syncResultCardStates(options) {
        var cards = document.querySelectorAll('#take-drive-map-results .take-drive-google-map__result-card[data-store-code], #take-drive-map-results .take-drive-google-map__ambassador-card[data-store-code]');
        cards.forEach(function (card) {
          var code = String(card.getAttribute('data-store-code') || '');
          var resultKind = String(card.getAttribute('data-result-kind') || 'dealer');
          var active = code === selectedStoreCode;
          if (selectedResult && resultKind !== 'ambassador') {
            active = isSameResultIdentity({ code: code, resultKind: resultKind }, selectedResult.code, selectedResult.resultKind);
          }
          if (resultKind === 'ambassador') {
            active = false;
          }
          var expanded = resultKind === 'ambassador' ? true : isExpanded(code);
          card.classList.toggle('is-active', active);
          card.classList.toggle('is-expanded', expanded);
          if (card.hasAttribute('role')) {
            card.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            card.setAttribute('aria-pressed', active ? 'true' : 'false');
          }
          var hotspot = card.querySelector('[data-result-hotspot="true"]');
          if (hotspot) {
            hotspot.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            hotspot.setAttribute('aria-pressed', active ? 'true' : 'false');
          }
          var selectedSessionIds = {};
          getSelectedWorkshopSessionIdsForCode(code).forEach(function (sessionId) {
            selectedSessionIds[String(sessionId)] = true;
          });
          card.querySelectorAll('.take-drive-google-map__workshop-slot-button').forEach(function (button) {
            var sessionId = String(button.getAttribute('data-session-id') || '').trim();
            var isSelected = !!selectedSessionIds[sessionId];
            button.classList.toggle('is-selected', isSelected);
            button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          });
        });
        var fallbackEl = document.getElementById('take-drive-map-result-fallback');
        if (fallbackEl) {
          var fallbackActive = isFallbackResult(selectedResult);
          fallbackEl.classList.toggle('is-active', fallbackActive);
          fallbackEl.setAttribute('aria-pressed', fallbackActive ? 'true' : 'false');
        }
        var ambassadorGroup = document.querySelector('#take-drive-map-results .take-drive-google-map__result-group--ambassador');
        if (ambassadorGroup) {
          var ambassadorGroupHotspot = ambassadorGroup.querySelector('.take-drive-google-map__result-group-hotspot');
          var activeAmbassadorCodes = {};
          getSelectedAmbassadorResults().forEach(function (item) {
            var code = String(item && item.code || '').trim();
            if (code) activeAmbassadorCodes[code] = true;
          });
          if (selectedResult && selectedResult.resultKind === 'ambassador') {
            activeAmbassadorCodes[String(selectedResult.code || '').trim()] = true;
          }
          var hasSelectedAmbassadorGroup = getSelectedAmbassadorResults().length > 0;
          ambassadorGroup.classList.toggle('is-active', hasSelectedAmbassadorGroup);
          ambassadorGroup.classList.toggle('is-expanded', ambassadorGroupExpanded);
          if (ambassadorGroupHotspot) {
            ambassadorGroupHotspot.setAttribute('aria-pressed', hasSelectedAmbassadorGroup ? 'true' : 'false');
            ambassadorGroupHotspot.setAttribute('aria-expanded', ambassadorGroupExpanded ? 'true' : 'false');
          }
          ambassadorGroup.querySelectorAll('.take-drive-google-map__result-group-avatar').forEach(function (avatarEl) {
            var code = String(avatarEl.getAttribute('data-code') || '').trim();
            avatarEl.classList.toggle('is-selected', !!activeAmbassadorCodes[code]);
          });
        }
        if (!(options && options.skipMarkerSync)) {
          syncMarkerStates();
        }
        if (!(options && options.skipDiscoveryButtonSync)) {
          syncDiscoveryButtonState();
        }
        if (!(options && options.skipChoiceSummarySync)) {
          updateChoiceSummary();
        }
      }

      function selectFallbackOption(mode) {
        clearWorkshopSessionSelections();
        setSelectedAmbassadorResults([]);
        selectedStoreCode = FALLBACK_RESULT_CODE;
        selectedResult = buildFallbackResult(mode);
        syncResultCardStates();
      }

      function deselectStoreCode(code, options) {
        var targetStoreCode = String(code || '').trim();
        var targetResultKind = String(options && options.resultKind || '').trim();
        if (!targetStoreCode) return;
        expandedStoreCodes = expandedStoreCodes.filter(function (itemCode) {
          return String(itemCode || '').trim() !== targetStoreCode;
        });
        if (selectedResult
          && String(selectedStoreCode || '').trim() === targetStoreCode
          && String(selectedResult.resultKind || '').trim() === targetResultKind) {
          selectedStoreCode = '';
          selectedResult = null;
        }
        syncResultCardStates();
      }

      function toggleStoreCardSelection(code, options) {
        var targetStoreCode = String(code || '').trim();
        var targetResultKind = String(options && options.resultKind || '').trim();
        if (!targetStoreCode) return;

        // 检查当前卡片是否已经被选中
        var currentItem = stores.find(function (item) {
          if (String(item.code || '').trim() !== targetStoreCode) return false;
          if (targetResultKind && String(item.resultKind || 'dealer').trim() !== targetResultKind) return false;
          return true;
        });
        
        if (currentItem && isSelectedResultIdentity(currentItem)) {
          // 如果已经被选中，则取消选中
          deselectStoreCode(targetStoreCode, {
            panTo: !!(options && options.panTo),
            resultKind: targetResultKind
          });
        } else {
          // 如果没有被选中，则选中
          selectStoreCode(targetStoreCode, {
            panTo: !!(options && options.panTo),
            resultKind: targetResultKind
          });
        }
      }

      function selectStoreCode(code, options) {
        var previousStoreCode = String(selectedStoreCode || '').trim();
        var previousResultKind = String(selectedResult && selectedResult.resultKind || '').trim();
        var targetStoreCode = String(code || '').trim();
        var targetResultKind = String(options && options.resultKind || '').trim();
        var nextSelectedAmbassadorResults = Array.isArray(options && options.selectedAmbassadorResults)
          ? options.selectedAmbassadorResults.slice()
          : [];

        if (targetStoreCode === FALLBACK_RESULT_CODE) {
          collapseAllAmbassadorBios();
          selectFallbackOption();
          return;
        }

        if (targetResultKind === 'ambassador') {
          if (!nextSelectedAmbassadorResults.length) {
            nextSelectedAmbassadorResults = stores.filter(function (item) {
              return !!(item
                && item.resultKind === 'ambassador'
                && String(item.code || '').trim() === targetStoreCode);
            });
          }
        } else {
          nextSelectedAmbassadorResults = [];
        }

        var isChannelSwitch = previousResultKind && targetResultKind && previousResultKind !== targetResultKind;
        if (isChannelSwitch) {
          selectedStoreCode = '';
          selectedResult = null;
          setSelectedAmbassadorResults([]);
        }

        selectedStoreCode = targetStoreCode;
        setSelectedAmbassadorResults(nextSelectedAmbassadorResults);
        selectedResult = stores.find(function (item) {
          if (String(item.code || '').trim() !== selectedStoreCode) return false;
          if (targetResultKind && String(item.resultKind || 'dealer').trim() !== targetResultKind) return false;
          return true;
        }) || stores.find(function (item) {
          return String(item.code || '').trim() === selectedStoreCode;
        }) || null;

        var nextResultKind = String(selectedResult && selectedResult.resultKind || '').trim();
        var selectionChanged = previousStoreCode !== selectedStoreCode || previousResultKind !== nextResultKind;
        if (selectionChanged) {
          clearWorkshopSessionSelections(options && options.preserveSessionSelection ? selectedStoreCode : '');
          if (!(options && options.preserveSessionSelection)) {
            ensureDefaultWorkshopSessionSelection(selectedResult);
          }
        }
        
        if (selectedStoreCode && !(options && options.skipExpand)) ensureExpanded(selectedStoreCode);
        syncResultCardStates();
        var shouldPreserveAmbassadorOverview = targetResultKind === 'ambassador'
          && nextSelectedAmbassadorResults.length > 1;
        if (options && options.panTo && map) {
          if (shouldPreserveAmbassadorOverview) {
            fitAmbassadorSelectionBounds(nextSelectedAmbassadorResults);
          } else {
            var marker = getStoreMarkerByCode(selectedStoreCode, selectedResult && selectedResult.resultKind);
            if (marker) {
              map.panTo(getStoreMarkerPosition(marker));
              map.setZoom(Math.max(map.getZoom() || 10, 11));
            }
          }
        }
      }

      function renderResults(items, targetLat, targetLng) {
        var resultEl = document.getElementById('take-drive-map-results');
        var resultListEl = document.getElementById('takeDriveMapResultsList');
        if (!resultEl || !resultListEl) return;
        var shouldRestoreFallbackSelection = isFallbackResult(selectedResult);
        var fallbackSelectionMode = shouldRestoreFallbackSelection
          ? String(selectedResult && selectedResult.fallbackMode || 'with_results').trim()
          : '';
        if (takeDriveClarity) {
          takeDriveClarity.trackSearchResultsView(items);
        }
        bindResultListScrollRelease();
        ambassadorGroupExpanded = true;
        if (!items.length) {
          resultEl.classList.remove('has-results');
          resultListEl.innerHTML = buildFallbackOptionHtml('empty');
          clearStoreMarkers();
          if (Number.isFinite(Number(targetLat)) && Number.isFinite(Number(targetLng)) && !(Number(targetLat) === 0 && Number(targetLng) === 0)) {
            previewTargetLocationOnMap(targetLat, targetLng, 10);
          }
          if (!isFallbackResult(selectedResult)) {
            setSelectedAmbassadorResults([]);
            selectedStoreCode = '';
            selectedResult = null;
          }
          expandedStoreCodes = [];
          syncResultCardStates();
          setNoResultBlocksVisible(true);
          bindFallbackOption(resultEl);
          return;
        }

        resultEl.classList.add('has-results');
        setNoResultBlocksVisible(true);
        var ambassadors = getDisplayAmbassadorItems(items);
        var others = items.filter(function (item) { return item.resultKind !== 'ambassador'; });
        var parts = [];
        var selectedAmbassadorCodes = {};
        getSelectedAmbassadorResults().forEach(function (item) {
          var code = String(item && item.code || '').trim();
          if (code) selectedAmbassadorCodes[code] = true;
        });

        if (ambassadors.length) {
          var previewAvatarEntries = [];
          ambassadors.forEach(function (item) {
            var ambassadorCode = String(item && item.code || '').trim();
            var isPreviewSelected = isSelectedResultIdentity(item) || !!selectedAmbassadorCodes[ambassadorCode];
            var urls = getAmbassadorAvatarUrls(item);
            if (urls.length) {
              urls.forEach(function (url) {
                previewAvatarEntries.push({
                  code: ambassadorCode,
                  isSelected: isPreviewSelected,
                  url: url
                });
              });
              return;
            }
            var initials = String(item && item.name || 'A').trim().split(/\s+/).map(function (part) {
              return String(part || '').charAt(0).toUpperCase();
            }).join('').slice(0, 2) || 'A';
            previewAvatarEntries.push({
              code: ambassadorCode,
              isSelected: isPreviewSelected,
              initials: initials
            });
          });
          var previewIcons = previewAvatarEntries.slice(0, 8).map(function (entry) {
            var avatarClassName = 'take-drive-google-map__result-group-avatar' + (entry.isSelected ? ' is-selected' : '');
            if (entry.url) {
              return '<span class="' + avatarClassName + '" data-code="' + escapeHtml(entry.code) + '"><img src="' + escapeHtml(entry.url) + '" alt="" loading="lazy" decoding="async"></span>';
            }
            return '<span class="' + avatarClassName + '" data-code="' + escapeHtml(entry.code) + '"><span class="take-drive-google-map__result-group-avatar-fallback">' + escapeHtml(entry.initials || 'A') + '</span></span>';
          }).join('');
          var ambassadorGroupDistanceLabel = buildAmbassadorGroupDistanceLabel(ambassadors);
          parts.push(
            '<div class="take-drive-google-map__result-group take-drive-google-map__result-group--ambassador" data-group-kind="ambassador">'
            + '<div class="take-drive-google-map__result-group-hotspot" tabindex="0" role="button" aria-pressed="' + (ambassadorGroupExpanded ? 'true' : 'false') + '" aria-expanded="' + (ambassadorGroupExpanded ? 'true' : 'false') + '">'
            + '<div class="take-drive-google-map__result-group-hero">'
            + '<div class="take-drive-google-map__result-group-hero-top">'
            + '<div class="take-drive-google-map__result-group-avatars">' + previewIcons + '</div>'
            + '</div>'
            + '<div class="take-drive-google-map__result-group-title">' + escapeHtml(takeDriveUiCopy.ambassadorGroupTitle) + '</div>'
            + (ambassadorGroupDistanceLabel ? '<div class="take-drive-google-map__result-group-distance">' + escapeHtml(ambassadorGroupDistanceLabel) + '</div>' : '')
            + '<div class="take-drive-google-map__result-group-count take-drive-google-map__result-group-count--ambassador">' + escapeHtml(String(ambassadors.length)) + ' ' + escapeHtml(takeDriveUiCopy.ambassadorGroupCountSuffix) + '</div>'
            + '</div>'
            + '<div class="take-drive-google-map__result-group-notices">'
            + '  <div class="take-drive-google-map__result-group-notice">'
            + '    <span class="take-drive-google-map__result-group-notice-icon" aria-hidden="true"><img src="' + escapeHtml(takeDriveResultsAssetUrls.know || '') + '" alt="" width="18" height="18" loading="lazy" decoding="async"></span>'
            + '    <div class="take-drive-google-map__result-group-hint">' + escapeHtml(takeDriveUiCopy.ambassadorGroupNoticeDeposit) + '</div>'
            + '  </div>'
            + '  <div class="take-drive-google-map__result-group-notice">'
            + '    <span class="take-drive-google-map__result-group-notice-icon" aria-hidden="true"><img src="' + escapeHtml(takeDriveResultsAssetUrls.know || '') + '" alt="" width="18" height="18" loading="lazy" decoding="async"></span>'
            + '    <div class="take-drive-google-map__result-group-hint">' + escapeHtml(takeDriveUiCopy.ambassadorGroupNoticeAvailability) + '</div>'
            + '  </div>'
            + '</div>'
            + '</div>'
            + '</div>'
          );
        }

        others.sort(function (a, b) {
          var orderMap = { workshop: 1, dealer_workshop: 2, dealer: 3 };
          var left = orderMap[a.resultKind] || 9;
          var right = orderMap[b.resultKind] || 9;
          if (left !== right) return left - right;
          if (a.resultKind === 'workshop' && b.resultKind === 'workshop') {
            var workshopSortDelta = getWorkshopDisplaySortRank(a) - getWorkshopDisplaySortRank(b);
            if (workshopSortDelta !== 0) return workshopSortDelta;
          }
          return a.distanceKm - b.distanceKm;
        });
        parts.push(others.map(buildResultCardHtml).join(''));
        parts.push(buildFallbackOptionHtml('with_results'));
        resultListEl.innerHTML = parts.join('');

        resultListEl.querySelectorAll('.take-drive-google-map__result-card[data-store-code], .take-drive-google-map__ambassador-card[data-store-code]').forEach(function (card) {
          var code = String(card.getAttribute('data-store-code') || '');
          var resultKind = String(card.getAttribute('data-result-kind') || 'dealer');
          var hotspot = card.querySelector('[data-result-hotspot="true"]');

          function handleToggle() {
            toggleStoreCardSelection(code, { panTo: true, resultKind: resultKind });
          }
          card.addEventListener('click', function (event) {
            if (hotspot) return;
            if (event.target && typeof event.target.closest === 'function' && event.target.closest('a, button, input, label')) return;
            
            event.stopPropagation();
            handleToggle();
          });

          card.addEventListener('keydown', function (event) {
            if (hotspot) return;
            if (!event || (event.key !== 'Enter' && event.key !== ' ')) return;
            event.preventDefault();
            
            event.stopPropagation();
            handleToggle();
          });

          if (hotspot) {
            hotspot.addEventListener('click', function (event) {
              if (event.target && typeof event.target.closest === 'function' && event.target.closest('a, button, input, label')) return;
              event.stopImmediatePropagation();
              event.preventDefault();
              
            handleToggle();
            });
            hotspot.addEventListener('keydown', function (event) {
              if (!event || (event.key !== 'Enter' && event.key !== ' ')) return;
              event.preventDefault();
              event.stopImmediatePropagation();

              handleToggle();
            });
          }
        });

        var groupEl = resultEl.querySelector('.take-drive-google-map__result-group--ambassador');
        if (groupEl) {
          var groupHotspot = groupEl.querySelector('.take-drive-google-map__result-group-hotspot');
          if (groupHotspot) {
            groupHotspot.addEventListener('click', function (event) {
              if (event.target && typeof event.target.closest === 'function' && event.target.closest('a, button, input, label')) return;
              event.stopPropagation();
              var isAmbassadorGroupSelected = getSelectedAmbassadorResults().length > 0
                && !(selectedResult && selectedResult.resultKind === 'ambassador');
              if (!isAmbassadorGroupSelected || !ambassadorGroupExpanded) {
                selectAmbassadorGroup(ambassadors, { panTo: true, expandGroup: true });
              } else {
                setSelectedAmbassadorResults(ambassadors);
                ambassadorGroupExpanded = true;
              }
              syncResultCardStates();
            });
            groupHotspot.addEventListener('keydown', function (event) {
              if (!event || (event.key !== 'Enter' && event.key !== ' ')) return;
              event.preventDefault();
              groupHotspot.click();
            });
          }
        }

        bindFallbackOption(resultEl);

        resultEl.querySelectorAll('.take-drive-google-map__workshop-slot-button').forEach(function (button) {
          button.addEventListener('click', function (event) {
            event.stopPropagation();
            var target = event.currentTarget;
            var storeCode = String(target && target.getAttribute('data-store-code') || '').trim();
            var sessionId = String(target && target.getAttribute('data-session-id') || '').trim();
            if (!storeCode || !sessionId) return;
            var nextSelected = String(target.getAttribute('aria-pressed') || 'false') !== 'true';
            setWorkshopSessionSelection(storeCode, sessionId, nextSelected);
            if (selectedStoreCode !== storeCode) {
              selectStoreCode(storeCode, { panTo: false, preserveSessionSelection: true });
              return;
            }
            selectedResult = stores.find(function (item) { return item.code === selectedStoreCode; }) || null;
            syncResultCardStates({ skipMarkerSync: true });
          });
        });

        clearStoreMarkers();
        var bounds = new google.maps.LatLngBounds();
        bounds.extend({ lat: targetLat, lng: targetLng });
        var markerAmbassadors = getMapAmbassadorItems(items);
        var markerItems = buildSpreadAmbassadorMarkerItems(markerAmbassadors).concat(others);
        markerItems.forEach(function (item) {
          var marker = createStoreMarker(item);
          storeMarkers.push(marker);
          bounds.extend(getStoreMarkerPosition(marker));
        });
        setTargetMarkerPosition(targetLat, targetLng);
        if (shouldRestoreFallbackSelection) {
          selectedStoreCode = FALLBACK_RESULT_CODE;
          setSelectedAmbassadorResults([]);
          collapseAllAmbassadorBios();
          selectedResult = buildFallbackResult(fallbackSelectionMode || 'with_results');
        } else {
          selectedStoreCode = '';
          setSelectedAmbassadorResults([]);
          collapseAllAmbassadorBios();
          selectedResult = null;
        }
        syncResultCardStates();
        map.fitBounds(bounds);
        if (discoveryActions) discoveryActions.style.display = '';
      }

      return {
        buildChoiceAvatarStackMarkup: buildChoiceAvatarStackMarkup,
        getChoiceLocationLabel: getChoiceLocationLabel,
        formatChoiceSessionDate: formatChoiceSessionDate,
        buildChoiceWorkshopSessionsMarkup: buildChoiceWorkshopSessionsMarkup,
        buildAmbassadorChoiceSummaryMarkup: buildAmbassadorChoiceSummaryMarkup,
        buildResultChoiceSummaryMarkup: buildResultChoiceSummaryMarkup,
        syncMarkerStates: syncMarkerStates,
        getSelectedResultCard: getSelectedResultCard,
        isExpanded: isExpanded,
        ensureExpanded: ensureExpanded,
        buildResultBadgesHtml: buildResultBadgesHtml,
        buildWorkshopAppliedHtml: buildWorkshopAppliedHtml,
        buildWorkshopNoticeHtml: buildWorkshopNoticeHtml,
        buildWorkshopScheduleHtml: buildWorkshopScheduleHtml,
        canContinueWithSelectedResult: canContinueWithSelectedResult,
        buildResultCardHtml: buildResultCardHtml,
        syncDiscoveryButtonState: syncDiscoveryButtonState,
        syncDetailsSubmitButtonState: syncDetailsSubmitButtonState,
        updateChoiceSummary: updateChoiceSummary,
        syncResultCardStates: syncResultCardStates,
        selectFallbackOption: selectFallbackOption,
        deselectStoreCode: deselectStoreCode,
        toggleStoreCardSelection: toggleStoreCardSelection,
        selectStoreCode: selectStoreCode,
        renderResults: renderResults
      };
    }
  };
})();
